import { render } from "./Borders.vue?vue&type=template&id=a87a4926"
import script from "./Borders.vue?vue&type=script&lang=ts"
export * from "./Borders.vue?vue&type=script&lang=ts"
script.render = render

export default script